import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_under_20_gifts: FaireThemeEntity = {
  token: "discovery_theme_under-20-gifts",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Under $20 Impulse Gifts",
  description: "Affordable finds your customers will love",
  bgColor: "#F0D4C4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
